import { connect } from 'react-redux';
import ConnectableInstanceWidgetStatistic from 'client/components/Instance/components/ConnectableInstanceWidgetStatistic';
import { instanceOptdReadStatistics } from 'client/redux/optd/statisticsActions';
import _ from 'lodash';

const mapStateToProps =  (state, props) => {
  const id = props.statistic;
  return {
    ...(state.optd.statistics[id] || {}),
    data: _.get(state, ['optd', 'statistics', id, 'data', id], null),
  };
};

const actions = {
  readStatistic: instanceOptdReadStatistics,
};

export default connect(mapStateToProps, actions)(ConnectableInstanceWidgetStatistic);
